import React, { FC } from 'react';
import styled from 'styled-components';
import { Container } from 'components/organisms/status-updates/list/styles';
import { StatusUpdateTemplateTabs } from './status-update-template-tabs';
import { StatusUpdateEditor } from './su-template-editor';

const Wrapper = styled.div`
  padding-top: var(--layout-04);
  height: 100%;
`;

export const StatusUpdateTemplate: FC = () => {
  const onMention = () => {
    return null;
  };

  return (
    <Wrapper>
      <Container>
        <StatusUpdateEditor onUserMention={onMention} />
        <StatusUpdateTemplateTabs />
      </Container>
    </Wrapper>
  );
};
